import React from 'react';
import { NavLink } from 'fluxible-router';
import shallowCompare from '../../lib/shallowCompare';
import Image from '../Image';
import styles from './index.sass';

class CollectionTile extends React.Component {

  static propTypes = {
    collection: React.PropTypes.object
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  render() {
    let { collection } = this.props;
    let description, photo;
    if(collection.description) {
      description = <p className={styles.description}>{collection.description.slice(0,300)} {collection.description.length > 300 ? '…' : ''}</p>;
    }
    if(collection.cover_photo_hash) {
      let imageProps = {
        tag: 'div',
        aspectRatio: (450 / 270),
        targetWidth: 450,
        photoHash: collection.cover_photo_hash
      };
      photo = <Image {...imageProps} />;
    }

    return (
      <NavLink className={styles.collection} routeName="collection" navParams={{slug: collection.slug}}>
        {photo}
        <h3 className={styles.title}>{collection.title}</h3>
        {description}
      </NavLink>
    );
  }
}

export default CollectionTile;



// WEBPACK FOOTER //
// banquet/components/CollectionTile/index.js